var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("line",{"strokeWidth":"2","strokeLinecap":"square","strokeMiterlimit":"10","x1":"1","y1":"14","x2":"14","y2":"1","key":0}),React.createElement("line",{"strokeWidth":"2","strokeLinecap":"square","strokeMiterlimit":"10","x1":"1","y1":"1","x2":"14","y2":"14","key":1})]);
}

X.defaultProps = {"x":"0px","y":"0px","width":"15px","height":"15px","viewBox":"0 0 15 15","enableBackground":"new 0 0 15 15","xmlSpace":"preserve"};

module.exports = X;

X.default = X;
